import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import TooltipCloseButton from './TooltipCloseButton';
import TooltipTertiaryButton from './TooltipTertiaryButton';

const TooltipBody = ({
  children,
  closeTooltipOnClick,
  showCloseButton,
  tertiaryBtn,
}) => {
  const tooltipBodyClasses = classnames(
    'ds-tooltip-body',
  );

  return (
    <div className={tooltipBodyClasses}>
      { showCloseButton &&
        <TooltipCloseButton
          onClick={closeTooltipOnClick}
        />
      }
      { children }
      { tertiaryBtn &&
        <TooltipTertiaryButton
          {...tertiaryBtn}
          closeTooltipOnClick={closeTooltipOnClick}
        />
      }
    </div>
  );
};

TooltipBody.defaultProps = {
  children: null,
  showCloseButton: false,
  tertiaryBtn: null,
};

TooltipBody.propTypes = {
  children: PropTypes.node,
  closeTooltipOnClick: PropTypes.func.isRequired,
  showCloseButton: PropTypes.bool,
  tertiaryBtn: PropTypes.shape({
    className: PropTypes.string,
    copy: PropTypes.string,
    enableCloseTooltip: PropTypes.bool,
    onClick: PropTypes.func,
  }),
};

export default TooltipBody;



// WEBPACK FOOTER //
// ./src-react/DesignSystem/Tooltips/components/TooltipBody.jsx